(() => {
  console.log("Free shipping goal JS loaded");

  const SELECTOR = ".ff-free-ship";

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === "function") {
      const fmt = window.Shopify.money_format || "${{amount}}";
      return Shopify.formatMoney(cents, fmt);
    }
    const currency =
      (window.Shopify && Shopify.currency && Shopify.currency.active) || "USD";
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency,
    }).format((cents || 0) / 100);
  }

  async function refreshFreeShippingGoal() {
    // IMPORTANT: re-query every time (cart drawer may re-render)
    const root = document.querySelector(SELECTOR);
    if (!root) return;

    const thresholdCents = parseInt(root.dataset.thresholdCents || "0", 10);
    if (!thresholdCents) return;

    const textEl = root.querySelector(".ff-free-ship__text");
    const fillEl = root.querySelector(".ff-free-ship__fill");

    try {
      const res = await fetch("/cart.js", { credentials: "same-origin" });
      const cart = await res.json();

      const totalCents = cart.total_price || 0;
      const remaining = thresholdCents - totalCents;
      const progress = Math.max(
        0,
        Math.min(100, Math.round((totalCents / thresholdCents) * 100))
      );

       if (fillEl) fillEl.style.width = progress + "%";

      if (textEl) {
        textEl.innerHTML =
          remaining > 0
            ? `You’re <strong>${formatMoney(remaining)}</strong> away from <strong>free shipping</strong>.`
            : `🎉 You’ve unlocked <strong>free shipping</strong>!`;
      }
    } catch (e) {
      console.warn("Free shipping goal update failed:", e);
    }
  }

  // Debounce so multiple mutations/clicks don't spam fetch
  let t;
  function scheduleRefresh() {
    clearTimeout(t);
    t = setTimeout(refreshFreeShippingGoal, 150);
  }

  function init() {
    // Initial
    scheduleRefresh();

    // Watch cart drawer changes (AJAX re-render)
    const drawer =
      document.querySelector("#CartDrawer") ||
      document.querySelector("cart-drawer") ||
      document.body;

    const obs = new MutationObserver(scheduleRefresh);
    obs.observe(drawer, { childList: true, subtree: true });

    // Also catch quantity button clicks/changes
    document.addEventListener("click", (e) => {
      const btn = e.target.closest('button[name="plus"], button[name="minus"], button[data-quantity-plus], button[data-quantity-minus]');
      if (btn) scheduleRefresh();
    });

    document.addEventListener("change", (e) => {
      if (e.target && e.target.matches('input[name="updates[]"], input[data-quantity-input]')) {
        scheduleRefresh();
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
